import React, { useState } from 'react';
import { ChatList } from './ChatList';
import { ChatDetail } from './ChatDetail';
import { aiAgentApi } from '../../../lib/aiAgentApi';
import { toast } from 'sonner';

/**
 * Two-state stack: list ↔ detail. Matches the wireframe (top screen = list,
 * bottom screen = chat detail). On mobile/iPad-like flows the user goes
 * back to the list with the arrow in the header.
 */
export const ChatsView = () => {
  const [activeConv, setActiveConv] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const openThread = (conv) => setActiveConv(conv);

  const newChat = async () => {
    try {
      const c = await aiAgentApi.createConversation();
      setActiveConv(c);
      setRefreshKey((k) => k + 1);
    } catch {
      toast.error('Could not start a new chat');
    }
  };

  if (activeConv) {
    return (
      <ChatDetail
        conv={activeConv}
        onBack={() => { setActiveConv(null); setRefreshKey((k) => k + 1); }}
        onChanged={() => setRefreshKey((k) => k + 1)}
      />
    );
  }
  return <ChatList refreshKey={refreshKey} onOpenThread={openThread} onNewChat={newChat} />;
};
